import { ShopifyCartItem } from '@/lib/shopify';
import { CartItemProperty, ITEM_ORIGINS } from '@/core/constants';
import {
  convertCartLineItemPropertiesToAttributes,
  getCartLineItemProperty,
} from '@/utils/shopify';

import { GiftSubscriptionSettings } from './types';

export function buildGiftSubscriptionKey(
  giftSubscriptionProduct: ShopifyCartItem,
): GiftSubscriptionSettings | null {
  const attributes = convertCartLineItemPropertiesToAttributes(
    giftSubscriptionProduct.properties,
  );

  const giftSubscriptionSettings = getCartLineItemProperty(
    CartItemProperty.PlayKitGiftSubscriptionSettings,
    attributes,
  );

  if (!giftSubscriptionSettings) {
    return null;
  }

  const identifiedGiftSubscriptionSettings =
    giftSubscriptionSettings as unknown as GiftSubscriptionSettings;

  const bundleAttributes = structuredClone(
    identifiedGiftSubscriptionSettings.bundle,
  );

  bundleAttributes.price = _convertToInt(bundleAttributes.price);
  bundleAttributes.size = _convertToInt(bundleAttributes.size);
  bundleAttributes.savings = _convertToInt(bundleAttributes.savings);

  return {
    ...identifiedGiftSubscriptionSettings,
    bundle: bundleAttributes,
    properties: {
      item_origin: ITEM_ORIGINS.GIFTING,
    },
  };
}

function _convertToInt(data: string | number) {
  if (typeof data === 'number') {
    return data;
  }

  const dataAsInt = Number(data);

  return isNaN(dataAsInt) ? data : dataAsInt;
}
